export { default } from './ErrorPage'
